















import Vue from 'vue';
import { uniqueId } from 'lodash';
import { ICreative } from '@/types/campaign/creatives';
import { getCreativeInit, getCropConfig } from '@/configs/creativeConfigs';
import NotificationService from '@/services/NotificationService';
import { createCropCoordinates } from '@/helpers/creativeHelpers';

const TYPE_FILES = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
];

export default Vue.extend({
  name: 'UploadFromPCCreatives',

  computed: {
    fileInput(): any {
      return this.$refs.filesInput as any;
    },
    typeFiles(): string {
      return TYPE_FILES.join(',');
    },
  },

  methods: {
    async handleFiles() {
      for (let i = 0; i < this.fileInput.files.length; i++) {
        const file = this.fileInput.files[i];
        await this.addFile(file);
      }

      this.$emit('upload', this.form.creatives);
      this.form.creatives = [];
      this.fileInput.value = null;
    },
    addFile(file) {
      const creative: ICreative = getCreativeInit();

      creative.id = uniqueId('new-');
      creative.file = file;
      creative.isNew = true;

      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();

        try {
          reader.onloadend = () => {
            creative.img = reader.result;
            image.src = reader.result + '';

            image.onload = () => {
              creative.sourceImg = {
                img: reader.result,
                width: image.width,
                height: image.height,
              };
              creative.width = image.width;
              creative.height = image.height;
              creative.coordinates = createCropCoordinates(image);

              this.form.creatives.push(creative);

              resolve(null);
            };
          };

          reader.readAsDataURL(file);
        } catch (err) {
          console.error(err);
        }
      });
    },
    selectFiles() {
      this.fileInput.click();
    },
  },

  data: function () {
    return {
      dropArea: null as HTMLElement | null,
      form: {
        creatives: [] as Array<ICreative>,
      },
    };
  },
});
